import React, { useContext, useState, useEffect } from 'react';

import { ThemeType } from 'shared/types';
import { theme as mainTheme, Theme } from 'shared/theme';

type ContextType = {
  themeType: ThemeType;
  setThemeType: (themeType: ThemeType) => void;
  theme: Theme;
  setTheme: (theme: Theme) => void;
  isBigHexView: boolean;
  setIsBigHexView: (isBigHexView: boolean) => void;
};
type Props = {
  children: React.ReactNode;
};

export const AppContextProvider = ({ children }: Props): JSX.Element => {
  const defaultThemeType: ThemeType = 'light';
  const [themeType, setThemeType] = useState<ThemeType>(defaultThemeType);
  const [theme, setTheme] = useState<Theme>(mainTheme[defaultThemeType]);
  const [isBigHexView, setIsBigHexView] = useState<boolean>(false);

  useEffect(() => {
    setTheme(mainTheme[themeType]);
  }, [themeType]);

  const value = {
    themeType,
    setThemeType,
    theme,
    setTheme,
    isBigHexView,
    setIsBigHexView,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const AppContext = React.createContext({} as ContextType);
export const useAppContext = (): ContextType => useContext(AppContext);
